import React, { useState, useEffect } from 'react'
import { motion, AnimatePresence } from "framer-motion"
import MentorHeader from '../components/MentorHeader';
import MentorSideBar from '../components/MentorSiderBar';
import { useQuery } from '@tanstack/react-query';
import { getApplicantsOfMeeting, getPayoutRequests } from '../utils/api';
import { useParams } from 'react-router-dom';
import * as moment from 'moment';
import { Eye } from 'lucide-react';

const MentorPayoutRequests = () => {
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [data, setData] = useState(null)
    const id = useParams()['id']
    const [isMobile, setIsMobile] = useState(false);
    const toggleSidebar = () => setSidebarOpen((prev) => !prev);
    useEffect(() => {
        const handleResize = () => {
            const mobile = window.innerWidth < 768;
            setIsMobile(mobile);
            if (mobile) setSidebarOpen(false);
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const { data: applicants } = useQuery({
        queryKey: ['applicants'],
        queryFn: () => getApplicantsOfMeeting(id)
    })
    const { data: mentorRequests, isLoading, refetch } = useQuery({
        queryKey: ['payoutrequests'],
        queryFn: getPayoutRequests
    })

    useEffect(() => {
        console.log(mentorRequests)
    }, [mentorRequests])

    const onEyeButtonClick = (applicant) => {
        console.log(applicant)
        setData(applicant)
        setShowModal(true)
    }

    useEffect(() => {
        console.log(applicants)
    }, [applicants])

    const headers = [
        "Requested On",
        "Amount",
        "Status",
    ];

    return (
        <>
            <div className="flex min-h-[100dvh] bg-gray-50 overflow-hidden">
                <MentorSideBar
                    isOpen={sidebarOpen}
                    toggleSidebar={toggleSidebar}
                    isMobile={isMobile}
                />

                <div className={`flex flex-col flex-1 transition-all duration-300 overflow-y-auto  ${isMobile ? "ml-0" : sidebarOpen ? "ml-16 md:ml-20 lg:ml-20" : "ml-0"}`}
                >
                    <MentorHeader toggleSidebar={toggleSidebar} isMobile={isMobile} />
                    <div className="px-6 pt-6 mt-3 ml-5 mr-5">
                        <h1 className="text-2xl font-bold text-gray-900">
                            Payout Requests
                        </h1>
                        <p className="mt-1 text-sm text-gray-600">
                            View and track your payout requests, including requested amounts,
                            current status, and processing history.
                        </p>
                    </div>

                    <motion.div
                        initial={{ opacity: 0, y: 16 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.4 }}
                        className="
       bg-white
       border border-gray-200
       rounded-2xl
       shadow-sm
       overflow-hidden 
       m-5
     "
                    >
                        <div className="relative overflow-x-auto">
                            <table className="w-full table-auto">
                                {/* HEADER */}
                                <thead className="sticky top-0 bg-gray-50 border-b border-gray-200 z-10">
                                    <tr>
                                        {headers?.map((h) => (
                                            <th
                                                key={h}
                                                className="
                   px-5 py-4 text-left
                   text-xs font-semibold
                   text-gray-600 uppercase tracking-wide
                   whitespace-nowrap
                 "
                                            >
                                                {h}
                                            </th>
                                        ))}
                                    </tr>
                                </thead>

                                {/* BODY */}
                                <tbody className="divide-y divide-gray-100">
                                    {mentorRequests?.payoutRequests?.length > 0 ? (
                                        mentorRequests?.payoutRequests?.map((each, i) => (
                                            <tr
                                                key={i}
                                                className="hover:bg-gray-50 transition-colors"
                                            >
                                                {/* Startup */}
                                                <td className="px-5 py-4">
                                                    <div className="font-semibold text-gray-900">
                                                        {each?.createdAt
                                                            ? moment(each.createdAt).format("DD MMM YYYY")
                                                            : "-"}
                                                    </div>
                                                </td>


                                                {/* Amount */}
                                                <td className="px-5 py-4 text-sm font-semibold text-gray-900">
                                                    ₹{Number(each?.amount).toLocaleString("en-IN")}
                                                </td>

                                                {/* Status */}
                                                <td className="px-5 py-4">
                                                    <span
                                                        className={`
      inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold
      ${each?.status === "pending"
                                                                ? "bg-yellow-100 text-yellow-700"
                                                                : each?.status === "approved"
                                                                    ? "bg-green-100 text-green-700"
                                                                    : "bg-red-100 text-red-700"
                                                            }
    `}
                                                    >
                                                        {each?.status?.charAt(0).toUpperCase() + each?.status?.slice(1)}
                                                    </span>
                                                </td>





                                            </tr>
                                        ))
                                    ) : (
                                        /* EMPTY STATE */
                                        <tr>
                                            <td
                                                colSpan={8}
                                                className="px-5 py-16 text-center"
                                            >
                                                <p className="text-sm text-gray-500">
                                                   No payout requests found
                                                </p>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </motion.div>

                </div>
            </div>




            {showModal && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
                    <div className="bg-white w-full max-w-xl rounded-2xl p-6 shadow-xl">

                        {/* Header */}
                        <h2 className="text-xl font-semibold mb-6 text-gray-800">
                            Meeting Details
                        </h2>

                        {/* Meeting Title */}
                        <div className="mb-4">
                            <p className="text-sm font-semibold text-gray-600 mb-1">
                                Meeting Title
                            </p>
                            <p className="text-gray-900 font-medium">
                                {data?.meetingId?.title || "-"}
                            </p>
                        </div>

                        {/* Date */}
                        <div className="mb-4">
                            <p className="text-sm font-semibold text-gray-600 mb-1">
                                Date
                            </p>
                            <p className="text-gray-900">
                                {data?.meetingId?.date
                                    ? moment(data.date).format("DD MMM YYYY")
                                    : "-"}
                            </p>
                        </div>

                        {/* Time */}
                        <div className="mb-4">
                            <p className="text-sm font-semibold text-gray-600 mb-1">
                                Time
                            </p>
                            <p className="text-gray-900">
                                {data?.meetingId?.startTime} – {data?.meetingId?.endTime}
                            </p>
                        </div>

                        {/* Meeting Type */}
                        <div className="mb-4">
                            <p className="text-sm font-semibold text-gray-600 mb-1">
                                Meeting Type
                            </p>
                            <span
                                className={`inline-flex px-3 py-1 rounded-full text-xs font-semibold
               ${data?.isPaid
                                        ? "bg-green-100 text-green-700"
                                        : "bg-gray-100 text-gray-700"}
             `}
                            >
                                {data?.isPaid ? "Paid Meeting" : "Free Meeting"}
                            </span>
                        </div>

                        {/* Amount (only if paid) */}
                        {data?.paymentStatus && (
                            <div className="mb-4">
                                <p className="text-sm font-semibold text-gray-600 mb-1">
                                    Amount Paid
                                </p>
                                <p className="text-gray-900 font-semibold">
                                    ₹{data?.amountPaid}
                                </p>
                            </div>
                        )}

                        {/* Divider */}
                        <hr className="my-6" />

                        {/* Applicant / Startup Info */}
                        <h3 className="text-sm font-semibold text-gray-700 mb-3">
                            Applicant Details
                        </h3>

                        <div className="space-y-3 text-sm">
                            <div>
                                <span className="text-gray-600">Startup Name:</span>{" "}
                                <span className="font-medium text-gray-900">
                                    {data?.startupId?.startupName || "-"}
                                </span>
                            </div>

                            <div>
                                <span className="text-gray-600">Founder Name:</span>{" "}
                                <span className="font-medium text-gray-900">
                                    {data?.startupId?.fullName || "-"}
                                </span>
                            </div>

                            <div>
                                <span className="text-gray-600">Email:</span>{" "}
                                <span className="font-medium text-gray-900">
                                    {data?.startupId?.email || "-"}
                                </span>
                            </div>
                        </div>

                        {/* Footer Actions */}
                        <div className="flex justify-end gap-3 mt-8">
                            <button
                                onClick={() => setShowModal(false)}
                                className="
               px-5 py-2 rounded-lg text-sm
               bg-gray-100 text-gray-700
               hover:bg-gray-200 transition
             "
                            >
                                Close
                            </button>

                        </div>

                    </div>
                </div>
            )}

        </>
    )
}

export default MentorPayoutRequests
